const inspection = {
  inspection: "창고 점검",
  draft: "임시 저장",
  pending: "진행 중",
  resolved: "완료",
  rejected: "취소됨",
  plState: "점검 상태를 선택하세요",
  state: "상태",
  number: "점검 번호",
  createdAt: "생성 시간",
  updatedAt: "작업 시간",
  planAt: "계획 시간",
  finishedAt: "완료 시간",
  remark: "비고",
  detail: "상세",
  add: "추가",
  saveOk: "저장 성공",
  saveErr: "저장 실패",
  del: "삭제",
  delOk: "삭제 성공",
  delErr: "삭제 실패",
  cancel: "취소",
  cancelTip: "이 점검 주문을 취소하시겠습니까?",
  cancelOk: "취소 성공",
  cancelErr: "취소 실패",
  notE: "존재하지 않음",
  exist: "존재함",
  partE: "부분 존재",
  notS: "불합격",
  suitable: "합격",
  partS: "부분 합격",
  notInspect: "미검",
  config: "점검 구성",
  needInspection: "점검 필요 여부",
  cycleDays: "점검 주기(일)",
  cycleDaysPlaceholder: "미입력 시 비정기/수시",
  content: "점검 내용 설명",
  yes: "예",
  no: "아니오",
  day: "일",
  plsSelectIns: "점검 필요 여부를 선택하세요",
  finish: "완료",
  finishTip: "이 점검 주문을 완료하시겠습니까?",
  finishOk: "점검 주문이 완료되었습니다",
  finishErr: "완료 실패",
  inspector: "점검자",
  locationCode: "로케이션 코드",
  existenceState: "존재 상태",
  complianceState: "준수도",
  action: "조치 사항",
  inspectedAt: "점검 시간",
  addOrder: "점검 주문 추가",
  plProduct: "점검할 자재를 선택하세요",
  plPlanAt: "점검 시간을 선택하세요",
  addProduct: "자재 추가",
  redPro: "빨간색 자재는 점검 구성이 없습니다",
  inspectProgress: "점검 진행률",
  inspectItem: "점검 항목",
  attechment: "점검 첨부파일",
  submitInspect: "점검 제출",
  submitSucc: "점검이 제출되었습니다",
  submitFail: "점검 제출 실패",
  inspect: "점검",
  specialHandlingAggregate: "보관 환경 상태",
  specialHandlingState: "보관 환경 복원",
  specialHandlingRemark: "비고",
  notSx: "미준수",
  suitablex: "준수",
  partSx: "부분 준수",
  notInspectx: "조치 불필요",
  unFinish: "미점검 항목이 있어 완료할 수 없습니다",
  orderCanceled: "이 점검 주문은 취소되어 점검 저장에 실패했습니다",
  orderFinished: "이 점검 주문은 완료되어 점검 저장에 실패했습니다",
  configExsist: "해당 요구사항 유형이 이미 존재하므로 추가할 필요가 없습니다",
};

export default inspection;
